import { ReactElement, useEffect, useState } from "react";
// import { ReactElement, useEffect, useState } from 'react'
import { IDelayBase } from "../../../types";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import { formatDateTimeWithSeconds } from "../../../system/utils";
// import TimePicker from '@material-ui/lab/TimePicker';

interface IDelayDialog {
  open: boolean;
  handleClose: any;
  selectedNewRow: IDelayBase;
  handleAccept?: any;
}

const layout = {
  marginTop: "1em",
  display: "grid",
  height: "125px",
  gridTemplateColumns: "auto auto auto 100px",
  // gridTemplateRows: "35px 35px 35px",
  gridTemplateRows: "1px 55px 55px",
  justifyContent: "start",
  // background: "Green"
};

const textOrginBeginStyle = {
  gridColumn: "2 / span 1",
  gridRow: "2 / span 1",
  // background: "#C0C0C0",
  margin: "0em 0.1em 0em 0.3em"
};

const textOrginEndStyle = {
  gridColumn: "3 / span 1",
  gridRow: "2 / span 1",
  // background: "#ABCDEE",
  margin: "0em 0.1em 0em 0.3em"
};

const textDurationStyle = {
  gridColumn: "4 / span 1",
  gridRow: "2 / span 1",
  // background: "#FEFEFE",
  margin: "0em 0.1em 0em 0.3em"
};

const textNewBeginStyle = {
  gridColumn: "2 / span 1",
  gridRow: "3 / span 1",
  // background: "#ABCFED",
  margin: "0em 0.1em 0em 0.3em"
};

const textNewEndStyle = {
  gridColumn: "3 / span 1",
  gridRow: "3 / span 1",
  // background: "Cyan",
  margin: "0em 0.1em 0em 0.3em"
};

const text34 = {
  gridColumn: "4 / span 1",
  gridRow: "3 / span 1",
  // background: "pink",
  margin: "0em 0.1em 0em 0.3em"
};

const CutDelayDialog = ({ open, handleClose, selectedNewRow, handleAccept }: IDelayDialog): ReactElement => {

  const [originalBegin, SetOriginalBegin] = useState("");
  const [originalEnd, SetOriginalEnd] = useState("");
  const [newEnd, SetNewEnd] = useState("");
  const [duration, setDuration] = useState<number>(0);
  const [maxDuration, setMaxDuration] = useState<number>(0);

  useEffect(() => {

    if (selectedNewRow) {

      const totalDuration = (selectedNewRow.endDatetime ? selectedNewRow.endDatetime : 0) - selectedNewRow.beginDatetime;
      setMaxDuration(totalDuration);

      // SetOriginalBegin(selectedNewRow.beginDatetime ? selectedNewRow.beginDatetime.toString() : "0");
      //
      // const bDay = new Date(selectedNewRow.beginDatetime * 1000);
      // //  SetOriginalBegin(bDay.toLocaleString());
      // SetOriginalBegin(bDay.toLocaleTimeString());

      SetOriginalBegin(formatDateTimeWithSeconds(selectedNewRow.beginDatetime));

      const nEDay = new Date(selectedNewRow.endDatetime ?selectedNewRow.endDatetime * 1000: 0);
      //  SetNewEnd(nEDay.toLocaleString());
      SetNewEnd(nEDay.toLocaleTimeString());

      const initialDuration = Math.round(totalDuration / 2);
      setDuration(initialDuration);
      //  setDuration(0);
    }
  }, [selectedNewRow]);

  useEffect(() => {
    // if (duration) {
    const originalD = (selectedNewRow.beginDatetime  + duration) * 1000;
    const nEndDate = new Date(originalD);
    // SetOriginalEnd(nEndDate.toLocaleString());
    SetOriginalEnd(nEndDate.toLocaleTimeString());
    // }
  }, [duration]);


  const onHandleAccept = () => {

    if (!selectedNewRow.production) {
      return;
    }

    if(selectedNewRow) {
      const a1 = (selectedNewRow.endDatetime ? selectedNewRow.endDatetime : 0) * 1000;
      const a2 = (selectedNewRow.beginDatetime + duration) * 1000;

      if(a1 === a2) {
        alert("Error: The original end time is the same that new end time!!!!");

        return;
      }

      handleAccept(selectedNewRow.production.productionID, selectedNewRow.production.machine.machineID, a2, a1, selectedNewRow.delayID);
    }
  };

  const onSetDuration = (durationTime: number) =>{
    if(durationTime > maxDuration) {
      return;
    }

    setDuration(durationTime);

  };

  return (
    <div>
      <Dialog maxWidth={"md"} open={open} onClose={handleClose} >
        <DialogTitle>Modify Delay</DialogTitle>
        <DialogContent dividers={true}>

          <div style={layout}>

            <div style={textOrginBeginStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="Original Begin"
                fullWidth = {true}
                value = {originalBegin}
                slotProps={{ input: { readOnly: true, }}}
              />

            </div>

            <div style={textOrginEndStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="Original End"
                fullWidth = {true}
                value = {originalEnd}
                slotProps={{ input: { readOnly: true, }}}
              />

            </div>

            <div style={textDurationStyle}>
              <TextField
                variant="standard"
                label="Duration"
                fullWidth={true}
                type="number"
                value={duration}
                onChange={e=> onSetDuration(Number(e.target.value)) }
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                  input: {
                    // startAdornment: <InputAdornment position="start">s</InputAdornment>,
                    endAdornment: <InputAdornment position="end">s</InputAdornment>,
                    inputProps: {
                      max: maxDuration,
                      min: 0
                    }
                  }
                }}
              />

            </div>



            <div style={textNewBeginStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="New Begin"
                fullWidth = {true}
                value = {originalEnd}
                slotProps={{ input: { readOnly: true, }}}
              />
            </div>

            <div style={textNewEndStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="New End"
                fullWidth = {true}
                value = {newEnd}
                slotProps={{ input: { readOnly: true, }}}
              />
            </div>

            <div style={text34}/>
          </div>

        </DialogContent>
        <DialogActions>
          {selectedNewRow.production &&
            <Button onClick={onHandleAccept} color="primary" variant="contained" >
              Accept
            </Button>
          }
          <Button onClick={handleClose} color="secondary" variant="contained" >
                        Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CutDelayDialog;
